export default __webpack_public_path__ + "static/media/Jest.749f89c6.svg";